import axios from 'axios';

// Get the API base URL from environment variable
// If REACT_APP_API_URL is set, use it (for production backend or custom backend)
// If not set, axios will use relative URLs which go through the package.json proxy
const API_BASE_URL = process.env.REACT_APP_API_URL || '';

// Configure axios default base URL if REACT_APP_API_URL is set
if (API_BASE_URL) {
  axios.defaults.baseURL = API_BASE_URL;
}

export default axios;

